import { useState, useEffect } from "react";

import { UserAPI } from "API/userApi";
import { IPerson } from "interfaces/intarfaces";
import { API_USERS, ERROR404, ERRORANY } from "utils/constants";

export const useFetchedData = (id: string | undefined) => {
  const [data, setData] = useState<IPerson | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (id) {
      setLoading(true);
      setError("");

      UserAPI.get(`${API_USERS}${id}`)
        .then((response) => {
          try {
            if (
              Object.keys(response).includes("status") &&
              response.status === 404
            ) {
              setError(ERROR404);
            } else if (response.hasOwnProperty("user_id")) {
              setData(response as IPerson);
            } else throw new Error();
          } catch {
            setError(ERRORANY);
          }
        })
        .catch((errorMsg) => {
          setError(errorMsg.message);
        })
        .finally(() => setLoading(false));
    } else {
      setData(undefined);
    }
  }, [id]);

  return { data, loading, error };
};
